class _SessionStorage {
  constructor() {}
  public setItem(key: string, value: string) {
    sessionStorage.setItem(key, value);
  }
  public getItem(key: string) {
    return sessionStorage.getItem(key);
  }
}

export const SessionStorage = (() => {
  return new _SessionStorage();
})();
